import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CONSTANTS } from '../constants/constants';
import { Observable } from 'rxjs';
import { ContactUsForm, ContactUsResponse } from '../types/contact-us.type';

@Injectable({
  providedIn: 'root',
})
export class ContactUsService {
  constructor(private http: HttpClient) {}

  create(contactUsForm: ContactUsForm): Observable<ContactUsResponse> {
    return this.http.post<ContactUsResponse>(
      `${CONSTANTS.BASE_API}contact-us`,
      contactUsForm
    );
  }
}
